import React from 'react';
import { connect } from 'react-redux';
import Warning from '../Warning';
import { trans } from '../../localization/language';
import * as commonActions from '../../actions/common';
import { bindActionCreators } from 'redux';


class SuspiciousNotification extends React.Component {
	whitelistMe() {
		this.props.initWhitelistUser();
	}
	render() {
		return (
			this.props.userInfo.suspicious?
			<Warning title={trans('important_notification')} message={trans('suspicious_login_hint')}>
				{ this.props.userInfo.whitelistable?
					<div>
						<div>- {trans('suspicious_change_stronger_pwd')}</div>
						<div><span className="action-link__with-underline" onClick={this.whitelistMe.bind(this)}>{trans('suspicious_it_was_me')}</span></div>
					</div>
						:
					<div>
						<div>- {trans('suspicious_add_verify_email')}</div>
						<div>- {trans('suspicious_bind_phone_number')}</div>
						<div>- {trans('suspicious_change_stronger_pwd')}</div>
					</div>
					 }
			</Warning>
				:
			null
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SuspiciousNotification);


// WEBPACK FOOTER //
// ./app/components/home/SuspiciousNotification.js